import type { ZudokuPlugin } from "zudoku";

const MATOMO_URL = "https://s.preo.cloud/";
const MATOMO_SITE_ID = "7";

const bootstrapScript = `
var _paq = window._paq = window._paq || [];
_paq.push(['trackPageView']);
_paq.push(['enableLinkTracking']);
(function() {
  var u="${MATOMO_URL}";
  _paq.push(['setTrackerUrl', u+'matomo.php']);
  _paq.push(['setSiteId', '${MATOMO_SITE_ID}']);
  var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
  g.async=true; g.src=u+'matomo.js'; s.parentNode.insertBefore(g,s);
})();
`.trim();

export const matomoPlugin: ZudokuPlugin = {
  getHead: () => (
    <script
      // biome-ignore lint/security/noDangerouslySetInnerHtml: Matomo bootstrap
      dangerouslySetInnerHTML={{ __html: bootstrapScript }}
    />
  ),
  events: {
    location: ({ to }) => {
      if (typeof window === "undefined") return;
      const paq = (window as unknown as { _paq?: unknown[] })._paq;
      if (!paq) return;
      paq.push(["setCustomUrl", to.pathname + to.search]);
      paq.push(["setDocumentTitle", document.title]);
      paq.push(["trackPageView"]);
      paq.push(["enableLinkTracking"]);
    },
  },
};
